export const InequalityRightBlue = () => {
  return (
    <svg width='15' height='24' viewBox='0 0 26 52' fill='none'>
      <path
        d='M4 48L19.5826 27.8343C20.4174 26.7539 20.4174 25.2461 19.5826 24.1657L4 4'
        stroke='#6696FF'
        stroke-width='10'
      />
    </svg>
  );
};
